import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import { Link, LinkIcon } from '../'
import config from '../../config'
import Styles from './AboutBanner.css'

@CSSModules(Styles)
export default class AboutBanner extends Component {
  static propTypes = {
  }
  constructor(props){
    super(props);
  }
  render() {
    return <div styleName='about-banner'>
      <Link
        to={config.routes.about}
        title='Learn more'
      >
        <div styleName='about-banner__flex'>
          <div styleName='about-banner__copy'>
            <h2 styleName='about-banner__title'>
              Defund deforestation
            </h2>
            <div styleName='about-banner__lede'>
              Built for investors who want to make a difference. Our unique dataset can help you ensure your money is making an impact.
            </div>
            <btn styleName='about-banner__button'>
              Learn more<LinkIcon />
            </btn>
          </div>
          <div styleName='about-banner__img' />
        </div>
      </Link>
    </div>
  }
}

